import { makeStyles } from '@material-ui/core';
import {
	BOGLE_MEDIUM,
	BOGLE_REGULAR,
	BOGLE_LIGHT,
	SPACE_BETWEEN,
} from '../../constants/constant';
import { colors } from '../../theme/color-palette';

const menuStyles = {
	menuItems: {
		fontSize: 16,
		fontWeight: 400,
		fontFamily: `${BOGLE_REGULAR} !important`,
		color: colors?.GREY,
		padding: '10px !important',
	},
	menuItemsType: {
		fontSize: 16,
		fontFamily: `${BOGLE_MEDIUM} !important`,
		fontWeight: `500 !important`,
		margin: `${'7% 0 1% 0'} !important`,
	},
	menu: {
		fontSize: 16,
		fontWeight: 300,
		fontFamily: `${BOGLE_LIGHT} !important`,
		color: colors?.FONT_COLOR,
	},
	addStore: {
		marginTop: '20px',
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
	},
	disableAddStore: {
		marginTop: '20px',
		display: 'flex',
		alignItems: 'center',
		cursor: 'not-allowed',
		color: '#6D6E71',
	},
};

export const useStyles = makeStyles((theme) => ({
	plusButtonContainer: {
		position: 'absolute',
		right: '15px',
		top: '115px',
		zIndex: theme.zIndex.snackbar - 1,
	},
	...menuStyles,
	container: {
		width: 360,
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
	comparisoncontainer: {
		'@media (min-width: 420px)': {
			width: 768,
		},
		'@media (max-width: 420px)': {
			margin: '0 auto 0 auto',
			width: '100%  !important',
		},
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
	},
	header: {
		margin: '22px 16px 0px 16px',
		display: 'flex',
		alignItems: 'center',
	},
	headerText: {
		display: 'inline-block',
		marginLeft: 22,
		fontFamily: BOGLE_MEDIUM,
		color: colors?.DARK_GRAY_SHADE,
		fontSize: 20,
		fontWeight: 500,
	},
	backBtn: {
		cursor: 'pointer',
		color: colors?.DARK_GRAY_SHADE,
	},
	content: {
		margin: '25px 16px 0 16px',
	},
	comparisoncontent: {
		margin: '25px auto',
	},
	notifyContent: {
		'@media (max-width: 420px)': {
			margin: '8px auto 30px auto',
			width: '95%  !important',
		},
		marginTop: '24px',
		display: 'flex',
		justifyContent: SPACE_BETWEEN,
		color: colors?.MID_GREY,
		alignItems: 'baseline',
		marginBottom: '30px',
	},
	addToWatchListBtnContainer: {
		marginTop: 'auto',
		marginBottom: '40px',
	},
	addToWatchlistBtn: {
		background: colors?.GREY,
		color: colors.WHITE,
		width: '328px',
		fontSize: 16,
		fontFamily: BOGLE_MEDIUM,
		'&:hover': {
			background: colors?.GREY,
		},
	},
	previewBtn: {
		background: colors.WHITE,
		color: colors.PURPLE,
		width: '328px',
		fontSize: 16,
		fontFamily: BOGLE_MEDIUM,
		fontWeight: '500',
		border: `1px solid ${colors.PURPLE}`,
	},
	enableAddToWatchlist: {
		background: colors.PURPLE,
		color: colors.WHITE,
		width: '328px',
		fontSize: 16,
		fontFamily: BOGLE_MEDIUM,
		'&:hover': {
			background: colors.PURPLE,
		},
	},
	metricBox: {
		'@media (max-width: 480px)': {
			margin: '0 auto 0 auto',
			width: '95%  !important',
		},
	},
	MuiAccordionroot: {
		'&.MuiAccordion-root:before': {
			backgroundColor: colors?.WHITE,
		},
		'& .MuiAccordion-root:nth-of-type(1)': {
			marginTop: '25px',
		},

		'& .MuiButtonBase-root': {
			borderTop: '1px solid lightgray !important',
			width: '100%',
		},
		'@media (max-width: 480px)': {
			marginTop: '5px !important',
		},
	},
	boxStyle: {
		display: 'block',
		'@media (max-width: 480px)': {
			marginBottom: '-4% !important',
		},
	},
	flexBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: SPACE_BETWEEN,
		alignItems: 'center',
	},
	list: {
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: '18px',
		'& >*:nth-of-type(1)': {
			flexGrow: 5,
		},
		'& >*:nth-of-type(2)': {
			flexGrow: 5,
		},
		'& >*:nth-of-type(3)': {
			flexGrow: 1,
		},
	},
	listStyle: {
		padding: '15px 0',
		borderBottom: `1px solid ${colors.LIGHT_GREY}`,
		'&:first-child': {
			paddingTop: '15px',
		},
	},
	noteListStyle: {
		padding: '15px 0 15px 10px',
		overflow: 'hidden',
	},
	accordionContent: {
		padding: '5px 10px',
	},
	searchInput: {
		display: 'flex',
		justifyContent: SPACE_BETWEEN,
		alignItems: 'center',
		fontSize: 8,
		gap: '8px',
		padding: '0px 8px',
		borderRadius: '8px',
		height: '37px',
		maxWidth: '100px',
		marginTop: '16px',
	},
	A: {
		fontSize: 16,
		fontFamily: `${BOGLE_MEDIUM} !important`,
		fontWeight: `500 !important`,
		marginLeft: `${'5%'} !important`,
	},
	inputLabel: {
		fontSize: 14,
		fontFamily: BOGLE_LIGHT,
	},
	supportLink: {
		color: colors.ERROR_HIGH,
	},
}));

export const styles = {
	plusButton: {
		backgroundColor: colors.PURPLE,
		'&:hover': {
			backgroundColor: colors.PURPLE,
		},
	},
	itemTypeSelect: {
		marginTop: '24px',
	},
	comparisonSelect: {
		marginTop: '24px',
		display: 'flex',
	},
	metricSelect: {
		width: '100%',
	},
	comMetricSelect: {
		width: '90%',
		'@media (max-width: 480px)': {
			width: '100%',
		},
	},
	notifyText: {
		marginTop: '8px',
		fontFamily: BOGLE_REGULAR,
		fontSize: 14,
	},
	textField: {
		fontSize: 14,
		fontFamily: BOGLE_LIGHT,
	},
	outline: {
		'& label.Mui-focused': {
			color: colors.PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: colors.PURPLE,
			},
		},
	},
};

export const textStyle = {
	'& label.Mui-focused': {
		color: colors.PURPLE,
	},
	'& .MuiOutlinedInput-root': {
		'&.Mui-focused fieldset': {
			borderColor: colors.PURPLE,
		},
	},
	width: 328,
};

export const selectStyleMenu = {
	'&& .MuiMenuItem-root': {
		display: 'flex !important',
		justifyContent: 'flex-start !important',
	},
	'&& .Mui-selected': {
		backgroundColor: colors?.BOLD_WHITE,
	},
	'&& .Mui-checked': {
		color: colors.PURPLE,
	},
	height: 300,
};
